import { Box, Grid, SxProps, Typography } from '@mui/material';
import React, { PropsWithChildren } from 'react';

interface Props {
  // ckey?: string;
  sx?: SxProps;
  gsx?: SxProps;
  gridLR?: [number, number, number?, number?];
  lastRow?: boolean;
  noBorder?: boolean;
}

const WsInfoFrameRow = (props: PropsWithChildren<Props>) => {
  const Children = React.Children.toArray(props.children);
  return (
    <Grid
      container
      item
      sx={{
        paddingTop: 1.5,
        paddingBottom: 1.5,
        ...(!props.lastRow && !props.noBorder && { borderBottom: '1px solid #d6d6d6' }),
        ...props.sx,
      }}
    >
      <Grid item xs={props.gridLR ? props.gridLR[0] : 2} sx={{ fontWeight: 600, ...props.gsx }}>
        {Children[0]}
      </Grid>
      <Grid item xs={props.gridLR ? props.gridLR[1] : 2} sx={{ ...props.gsx }}>
        {Children[1]}
      </Grid>
      {Children.length > 2 && (
        <Grid item xs={props.gridLR && props.gridLR[2] ? props.gridLR[2] : 4} sx={{ ...props.gsx }}>
          {Children[2]}
        </Grid>
      )}
      {Children.length > 3 && (
        <Grid item xs={props.gridLR && props.gridLR[3] ? props.gridLR[3] : 2} sx={{ ...props.gsx }}>
          {Children[3]}
        </Grid>
      )}
    </Grid>
    // <Grid
    //   sx={{
    //     // width: '100%',
    //     paddingTop: 1,
    //     paddingBottom: 1,
    //     ...(!props.lastRow && { borderBottom: '1px solid #d6d6d6' }),
    //     ...props.sx,
    //   }}
    //   item
    //   xs={12}
    // >
    //   <Grid item xs={4} sx={{ fontWeight: 600 }}>
    //     {Children[0]}
    //   </Grid>
    //   <Grid item xs={8}>
    //     {Children[1]}
    //   </Grid>
    // </Grid>
  );
};

export default WsInfoFrameRow;
